export interface ISetOrResetPasswordRequest {
    password: string;
    email: string;
    oobCode: string;
    acceptPolicy?: boolean;
    subscribeMarketing?: boolean;
}
